import { Dispatch, FC, SetStateAction } from 'react';
import clsx from 'clsx';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import { useMutation, useQueryClient } from 'react-query';
import { toggleVideoFavorite, toggleVideoWatched } from 'api/videos';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { IconButton } from '@mui/material';

type Props = {
    /**
     * Массив видео.
     */
    video: any;

    /**
     * Функция выбора просмотра видео.
     */
    selectVideo: Dispatch<SetStateAction<{ id: any }>>;
};

const VideoCard: FC<Props> = ({ video, selectVideo }) => {
    const queryClient = useQueryClient();

    const videoWatchedMutation = useMutation(toggleVideoWatched, {
        onSuccess: () => {
            queryClient.invalidateQueries('videos');
        },
    });

    const videoFavoriteMutation = useMutation(toggleVideoFavorite, {
        onSuccess: () => {
            queryClient.invalidateQueries('videos');
            queryClient.invalidateQueries('videos-watch');
        },
    });

    // const rateVideoMutation = useMutation(rateVideo, {
    //     onSuccess: () => {
    //         queryClient.invalidateQueries('videos');
    //     },
    // });
    //
    // const onRateVideo = (val: number) => {
    //     rateVideoMutation.mutate({ id: video.id, rating: val / 20 });
    // };

    const toggleWatched = () => {
        videoWatchedMutation.mutate(video.id);
    };

    const toggleFavorite = async () => {
        videoFavoriteMutation.mutate(video.id);
    };

    return (
        <div
            onClick={() => selectVideo(video)}
            className={clsx(
                'w-full rounded-xl bg-white p-4 shadow-md hover:shadow-lg transition-shadow flex flex-col gap-4 cursor-pointer',
                video.watched && 'opacity-50'
            )}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 flex-1 overflow-hidden" onClick={e => e.stopPropagation()}>
                    <IconButton onClick={toggleFavorite} size="small">
                        {video.favorite ? (
                            <FavoriteIcon className="text-red-500" fontSize="small" />
                        ) : (
                            <FavoriteBorderIcon className="text-gray-400" fontSize="small" />
                        )}
                    </IconButton>
                    <p className="text-base font-semibold text-gray-900 truncate">{video.title}</p>
                </div>
                <div className="ml-3 flex-shrink-0" onClick={e => e.stopPropagation()}>
                    <Tooltip title={video.watched ? 'Пометить не просмотренным' : 'Пометить просмотренным'}>
                        <Checkbox onChange={toggleWatched} checked={video.watched} className="p-0" />
                    </Tooltip>
                </div>
            </div>

            {video.description && <p className="text-sm text-gray-600 leading-snug">{video.description}</p>}

            <div className="flex justify-between items-center text-sm text-gray-500">
                <span>Автор(ы): {video.authors.join(', ')}</span>
            </div>

            <div className="flex flex-wrap gap-1 text-xs">
                {video.tags.map((tag: string, i: number) => (
                    <span key={i} className="bg-gray-200 text-gray-700 px-2 py-1 rounded-full font-medium">
                        {tag}
                    </span>
                ))}
            </div>

            <div className="mt-auto pt-4 text-right text-xs text-gray-400">{video.recorded_date}</div>
        </div>
    );
};

export default VideoCard;
